import type { Venue } from "../types";
import {
  addressFieldsFromEntity,
  emptyAddressForm,
  formatDisplayAddress,
  formatPostalAddress,
  primaryCityFromEntity,
  type AddressFormState,
} from "./addressForm";

export type { AddressFormState };

export type VenueFormState = AddressFormState & {
  venue_name: string;
  capacity: string;
  base_cost: string;
};

export const emptyVenueForm: VenueFormState = {
  venue_name: "",
  capacity: "",
  base_cost: "",
  ...emptyAddressForm,
};

export const formatVenueLocation = formatPostalAddress;

export function formatVenueDisplayAddress(venue: Venue): string {
  return formatDisplayAddress(venue);
}

export function venueToForm(venue: Venue): VenueFormState {
  return {
    venue_name: venue.venue_name,
    capacity: venue.capacity != null ? String(venue.capacity) : "",
    base_cost: venue.base_cost != null ? String(venue.base_cost) : "",
    ...addressFieldsFromEntity(venue),
  };
}

export function buildVenuePayload(form: VenueFormState) {
  return {
    venue_name: form.venue_name.trim(),
    location: formatPostalAddress(form),
    address_line1: form.address_line1.trim() || null,
    address_line2: form.address_line2.trim() || null,
    landmark: form.landmark.trim() || null,
    city: form.city.trim() || null,
    district: form.district.trim() || null,
    state: form.state.trim() || null,
    pincode: form.pincode.trim() || null,
    country: form.country.trim() || "India",
    capacity: form.capacity ? Number(form.capacity) : null,
    base_cost: form.base_cost ? Number(form.base_cost) : null,
  };
}

export function venuePrimaryCity(venue: Venue): string {
  return primaryCityFromEntity(venue);
}
